import React from "react";

const IRPJCSLL = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /irpj-csll funcionando ✅</h1>
    </div>
  );
};

export default IRPJCSLL;